<section *ngIf="(activeStepIndex$ | async) !== undefined">
  <ng-container *ngIf="steps$ | async as steps">
    <eb-generic-page-stepper
      [steps]="steps"
      [activeStep]="activeStepIndex$ | async"
      class="eb-checkout-progress__stepper"
    ></eb-generic-page-stepper>
  </ng-container>
</section>
